<template>
  <div>
    <b-modal
      title="Bulk Upload"
      v-model="showBulkUploadModal"
      size="lg"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div>
        <div
          class="text-center"
          v-if="!submiting && !responseSuccess"
        >
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            @vdropzone-success="vsuccess"
            :options="dropzoneOptions"
            :useCustomSlot="true"
            class="m-5 p-3"
            style="border:dashed 1px"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
              <div class="subtitle">...or click to select a file from your computer</div>
            </div>
          </vue-dropzone>
          <p>
            Download Sample Excel File
            <b-btn
              size="sm"
              variant="outline-info"
              @click="downloadSampleExcel"
            >
              <font-awesome-icon icon="file-excel" />
            </b-btn>
          </p>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Your Bulk is being Uploading......</p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Your Bulk has been uploaded successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="float-right">
          <b-button
            class="mr-3"
            variant="outline-danger"
            v-if="!uploading"
            @click="resetModal"
          >Cancel</b-button>
          <b-button
            variant="outline-success"
            v-if="!uploading && !responseSuccess"
            @click="uploadFile"
          >Upload</b-button>
        </div>
      </template>
    </b-modal>
    <b-toast
      variant="danger"
      title="Bulk Upload"
      v-model="errorToast"
      solid
      append-toast
      auto-hide-delay="9000"
      v-for="(errorMsg,errorMsgIndex) in errorToastMsg"
      :key="errorMsgIndex"
    >
      <p v-html="sanitizeHtml(errorMsg)"></p>
    </b-toast>
  </div>
</template>
<script>
import VueDropzone from "../../../components/Dropzone/VueDropzone.vue";
import { EventBus } from "@/event-bus.js";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import { getAccessToken } from "@/utils/auth-requests";
export default {
  name: "BulkUploadEmployee",
  components: {
    VueDropzone,
  },
  data () {
    return {
      errorToast: false,
      errorToastMsg: [],
      showBulkUploadModal: false,
      uploading: false,
      isLoading: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL + "api/v1/employees/rs/upload/" + localStorage.getItem( "userId" ),
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        accept: ( file, done ) => {
          const name = file.name.toLowerCase();
          const dots = ( name.match( /\./g ) || [] ).length;

          if ( dots !== 1 ) {
            this.$bvToast.toast( this.$t( "upload.doubleExtensionMessage" ), {
              title: this.$t( "toast.title" ),
              variant: "danger",
              autoHideDelay: 8000,
              solid: true,
            } );
            return done( this.$t( "upload.invalidFileMessage" ) );
          }

          const extension = name.split( "." ).pop();
          if ( ![ "xlsx", "xls", "csv" ].includes( extension ) ) {
            this.$bvToast.toast( this.$t( "upload.invalidFileTypeMessage" ), {
              title: this.$t( "toast.title" ),
              variant: "danger",
              autoHideDelay: 8000,
              solid: true,
            } );
            return done( this.$t( "upload.invalidFileTypeMessage" ) );
          }
          done();
        },
      },
      submiting: false,
      responseSuccess: false,
    };
  },
  created () {
    EventBus.$on( "onShowBulkUploadEmployeeModal", () => {
      this.showBulkUploadEmployee();
    } );
  },
  methods: {
    sanitizeHtml,
    showBulkUploadEmployee () {
      this.showBulkUploadModal = true;
    },
    vsuccess ( file, response ) {
      this.errorToastMsg = [];
      this.errorToast = false;
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      this.resetModal();
      if ( response && response.status == 0 ) {
        this.errorToastMsg = response.excelErrors;
        this.errorToast = true;
      } else if( response && response.status == 1 ){
        this.$bvToast.toast(
          "Your bulk upload file has been successfully uploaded and is now processed",
          {
            title: "File Upload is complete",
            variant: "success",
            noAutoHide: false,
            appendToast: true,
          }
        );
      } else {
        this.$bvToast.toast(
          "File has not been uploaded successfully. Something went wrong!",
          {
            title: "Bulk Upload",
            variant: "danger",
            noAutoHide: false,
            appendToast: true,
          }
        );
      }
      this.$refs.myVueDropzone.removeAllFiles();
      this.reloadTable();
    },
    async uploadFile () {
      if ( this.$refs.myVueDropzone.getQueuedFiles().length > 0 ) {
        this.uploading = true;
        // Dropzone posts with its own XHR, so the axios interceptor never adds the token
        const accessToken = await getAccessToken( this.$store ) || localStorage.getItem( "accessToken" );
        this.$refs.myVueDropzone.setOption( "headers", {
          Authorization: "Bearer " + accessToken,
        } );
        this.$refs.myVueDropzone.processQueue();
      }
    },
    resetModal () {
      this.showBulkUploadModal = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.uploading = false;
    },
    downloadSampleExcel () {
      window.location.href = process.env.VUE_APP_API_URL + "/BulkUpload/Employee_Upload_Template.xlsx";
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-table" );
    },
  },
};
</script>